<template>
  <main class="service-page">
    <header class="service-hero">
      <p class="brand">清北博雅 · 学员服务说明</p>
      <h1>课程开通与学习服务说明</h1>
      <p class="lead">学员报名后，我们将根据所报课程和服务安排，完成信息核对、课程开通及学习对接。课程支持手机 APP 和电脑网页端观看，学习期间可按照实际班型与课程权益获得相应学习支持。</p>
      <div class="hero-note">具体课程、服务群、资料、答疑、督学、一对一或后续服务内容，以学员报名班型、签署协议及实际开通权益为准。</div>
    </header>

    <div class="keypoints">
      <article class="key"><strong>课程开通有路径</strong><p>完成信息确认后，老师会对接课程开通、群内沟通和学习安排。</p></article>
      <article class="key"><strong>看课方式更方便</strong><p>支持手机 APP 与电脑网页端查看课程、进入直播及下载电子资料。</p></article>
      <article class="key"><strong>学习过程有支持</strong><p>按实际权益提供课程提醒、答疑、学习计划、测试反馈等服务。</p></article>
    </div>

    <section class="service-section">
      <div class="section-head"><h2>报名后，如何进入学习</h2><span class="sub">标准课程服务的一般办理路径</span></div>
      <div class="steps-line steps-7">
        <article class="step"><div class="num">01</div><h3>报名信息确认</h3><p>登记所报课程及基础信息。</p></article>
        <article class="step"><div class="num">02</div><h3>老师首次联系</h3><p>核对课程并说明服务安排。</p></article>
        <article class="step"><div class="num">03</div><h3>协议与服务沟通</h3><p>签署协议，建立对应沟通渠道。</p></article>
        <article class="step"><div class="num">04</div><h3>课程开通</h3><p>开通已报名课程并告知看课方式。</p></article>
        <article class="step"><div class="num">05</div><h3>学习计划与资料</h3><p>结合情况安排学习建议和资料。</p></article>
        <article class="step"><div class="num">06</div><h3>学习过程跟进</h3><p>进行提醒、答疑和进度支持。</p></article>
        <article class="step"><div class="num">07</div><h3>阶段检测与提醒</h3><p>结合课程进行测试和节点提醒。</p></article>
      </div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>课程如何观看</h2><span class="sub">已开通课程可通过以下方式进入学习</span></div>
      <div class="learning" style="display:grid;grid-template-columns:1fr 1fr;gap:16px;">
        <article class="device" style="border:1px solid #ead7d8;border-radius:16px;background:#fbfdff;padding:22px 23px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;"><h3 style="margin:0;color:#61030d;font-size:20px;">手机 APP 观看</h3><span class="badge" style="background:#f8e8ea;color:#8c0b18;font-size:12px;font-weight:700;padding:4px 10px;border-radius:999px;">适合随时学习</span></div>
          <ol style="margin:0;padding-left:22px;color:#282224;font-size:14px;"><li style="margin:9px 0;padding-left:4px;">在应用商店搜索"清北博雅"并完成安装。</li><li style="margin:9px 0;padding-left:4px;">使用报名手机号或老师通知的登录方式进入账户。</li><li style="margin:9px 0;padding-left:4px;">点击"课程—我的课程"，查看已开通课程。</li><li style="margin:9px 0;padding-left:4px;">选择课程章节进行学习；当日直播可通过"我的—学习日历"进入。</li><li style="margin:9px 0;padding-left:4px;">电子资料可在课程资料或讲义相关入口下载查看。</li></ol>
        </article>
        <article class="device" style="border:1px solid #ead7d8;border-radius:16px;background:#fbfdff;padding:22px 23px;">
          <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;"><h3 style="margin:0;color:#61030d;font-size:20px;">电脑网页端观看</h3><span class="badge" style="background:#f8e8ea;color:#8c0b18;font-size:12px;font-weight:700;padding:4px 10px;border-radius:999px;">适合集中学习</span></div>
          <ol style="margin:0;padding-left:22px;color:#282224;font-size:14px;"><li style="margin:9px 0;padding-left:4px;">打开清北博雅电脑网页端学习入口。</li><li style="margin:9px 0;padding-left:4px;">按照老师通知的登录方式进入个人中心。</li><li style="margin:9px 0;padding-left:4px;">点击"我的课程"，查看已开通课程。</li><li style="margin:9px 0;padding-left:4px;">通过"学习日历"查看并进入当日直播课程。</li><li style="margin:9px 0;padding-left:4px;">电子资料可下载至本地查看。</li></ol>
          <div style="margin-top:16px;background:#fbf1f2;border:1px solid #e8d0d3;border-radius:11px;padding:12px 13px;font-size:13.5px;color:#66343a;word-break:break-all;">电脑网页端学习入口：<a href="https://www.qbbystudy.com/pc/member/study" target="_blank" rel="noopener">https://www.qbbystudy.com/pc/member/study</a></div>
        </article>
      </div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>学习期间可获得的支持</h2><span class="sub">服务内容以实际报名权益为准</span></div>
      <div class="support-grid">
        <article class="support-card"><b>课程安排与提醒</b><span>课程开通、直播提醒、阶段学习安排及关键时间节点提示。</span></article>
        <article class="support-card"><b>学习规划与跟进</b><span>结合学习情况提供相应计划建议、进度跟进或阶段反馈。</span></article>
        <article class="support-card"><b>答疑与学习反馈</b><span>根据课程服务安排，对学习疑问、练习或测试问题提供支持。</span></article>
        <article class="support-card"><b>资料与讲义</b><span>已开通课程相关电子资料可下载，纸质资料按课程安排发放。</span></article>
        <article class="support-card"><b>测试与模考</b><span>部分课程包含入学测、阶段测、模考或相关讲评安排。</span></article>
        <article class="support-card"><b>后续服务衔接</b><span>涉及择校、复试或其他增值服务的，以所报班型权益为准。</span></article>
      </div>
    </section>

    <section class="service-section">
      <div class="section-head"><h2>一对一课程如何匹配</h2><span class="sub">仅适用于报名内容中包含一对一服务的学员</span></div>
      <div style="display:grid;grid-template-columns:repeat(5,1fr);gap:11px;">
        <article style="padding:17px 14px;border-radius:13px;background:#fbf1f2;border:1px solid #e8d0d3;min-height:130px;" v-for="(s,i) in otoSteps" :key="i"><em style="font-style:normal;color:#8c0b18;font-size:13px;font-weight:700;">{{ s.num }}</em><b style="display:block;color:#282224;font-size:15px;margin:7px 0 4px;">{{ s.title }}</b><p style="font-size:13px;color:#6d6062;margin:0;line-height:1.6;">{{ s.desc }}</p></article>
      </div>
      <div class="service-notice"><strong>说明：</strong>一对一匹配周期、试听安排、老师调整及课时处理方式，应以当前服务规则、协议约定和实际沟通结果为准。</div>
    </section>

    <section class="service-section faq">
      <div class="section-head"><h2>常见问题</h2></div>
      <details open><summary>报名后什么时候可以查看课程？</summary><p>完成必要的信息确认后，老师会根据您所报课程安排开通学习内容，并告知具体看课方式。实际开通时间以对接老师通知和课程安排为准。</p></details>
      <details><summary>课程只能在手机上看吗？</summary><p>不是。已开通课程支持通过清北博雅手机 APP 或电脑网页端查看，您可根据自己的学习习惯选择使用方式。</p></details>
      <details><summary>直播课程和电子资料在哪里查看？</summary><p>手机 APP 可通过"我的—学习日历"查看当日直播入口；电脑网页端可通过个人中心的"学习日历"进入。电子资料可在相应课程页面下载查看。</p></details>
      <details><summary>报名后都会安排一对一老师吗？</summary><p>一对一服务并非全部课程默认包含。是否包含一对一匹配及授课服务，以您所报班型、签署协议及实际开通权益为准。</p></details>
      <details><summary>学习过程中有问题如何反馈？</summary><p>您可通过老师告知的服务沟通渠道反馈课程学习相关问题，由对应老师根据服务安排协助处理。</p></details>
    </section>
  </main>
</template>

<script>
export default {
  name: "CourseActivation",
  data() {
    return {
      otoSteps: [
        { num: "01", title: "提交需求", desc: "说明专业、目标院校及课程需求。" },
        { num: "02", title: "匹配老师", desc: "结合需求与师资安排进行匹配。" },
        { num: "03", title: "试听沟通", desc: "确认授课方向和学习适配情况。" },
        { num: "04", title: "确认或反馈", desc: "确认老师，或反馈后继续处理匹配。" },
        { num: "05", title: "开始上课", desc: "制定安排后进入正式学习。" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/service-common.scss";
.service-hero {
  .lead { max-width: 845px; }
}
</style>
